
import React from 'react'
import '../../App.css';
// import './Card.css'
import { Link } from 'react-router-dom';
import { MdDownloadDone } from 'react-icons/md'
const CardItem = (props) => {
  return (
    <div className="myCard3 " >
      <img src={props.src} className="card-img-top" alt="mango image" />
      <div className="card-body ">
        <p className='text-muted'>{props.plan}</p>
        <h3 className="card-title">{props.title}</h3>
       
        <div className="itemCard my-3">
          <div className="d-flex mt-sm-2"><MdDownloadDone size="1.5em" /><p className='card-item '>{props.li1a}{props.li2a}</p></div>
          <div className="d-flex mt-sm-2"><MdDownloadDone size="1.5em" />   <p className='card-item '>{props.li1d}{props.li2d}</p></div>
          <div className="d-flex mt-sm-2"><MdDownloadDone size="1.5em" /> <p className='card-item '>{props.li1c}{props.li2c}</p></div>
          <div className="d-flex mt-sm-2"><MdDownloadDone size="1.5em" /> <p className='card-item '>{props.li1b}{props.li2b}</p></div>
         
        
        </div>
        <strong className=' text-center '><b>{props.price}</b></strong>
        <div className="my-1">
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
        </div>
        <Link to="/"><button className="btn btn-pri">Get it Now</button></Link>
      </div>
    </div>
  )
}
export default CardItem;